import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../../assets/themes/theme";
import showToast from "../../../services/toast";
import React from "react";
export var CollectHeader = function (props) {
    return (_jsxs(_Fragment, { children: [props.seeToast.show &&
                showToast(position.topRight, props.seeToast.type, props.seeToast.message, function () {
                    props.setSeeToast({ show: false, message: "", type: typeAlert.success });
                }), _jsx(LoadingAFY, { loading: props.loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: "Cargando...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third })] }));
};
